module.exports = __webpack_public_path__ + "static/img/2.8ed3917.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/picGrop1/2.jpg
// module id = 1exJ
// module chunks = 0